export const SailboatIcon = () => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 64 64' // Changed to match the path data's coordinate system
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill='currentColor' // Changed to currentColor to inherit color from parent
      d='M63.876,47.45c-0.173-0.305-0.495-0.494-0.846-0.494h-9.417v-0.65c0-0.987-0.386-1.915-1.087-2.611
      c-0.702-0.696-1.629-1.104-2.611-1.067H32.909v-1.771h29.048c0.766,0,1.44-0.432,1.761-1.128c0.294-0.64,0.225-1.362-0.176-1.926
      C58.082,24.376,47.631,12.642,32.47,2.923c-0.015-0.009-0.028-0.018-0.044-0.026C32.262,2.802,32.08,2.761,31.9,2.766
      c-0.058,0.002-0.116,0.01-0.175,0.023h-0.001c-0.231,0.053-0.442,0.189-0.585,0.398c-0.02,0.026-0.035,0.055-0.052,0.083v0
      c0,0-0.001,0-0.001,0.001c-0.081,0.15-0.12,0.315-0.117,0.477v38.878h-9.663c-1.319,0.009-2.526,0.68-3.19,1.735l-1.921,2.593H0.97
      c-0.351,0-0.673,0.189-0.846,0.494c-0.171,0.306-0.165,0.68,0.017,0.979l5.805,9.548c1.221,2.009,3.439,3.257,5.791,3.257h40.527
      c2.351,0,4.569-1.248,5.79-3.257l5.805-9.548C64.041,48.13,64.047,47.755,63.876,47.45z M61.794,38.652
      c0.038,0.098,0.095,0.185,0.163,0.265H33.566c4.978-9.748,5.204-21.574,0.68-32.49C47.585,15.573,56.844,26.401,61.794,38.652z
      M32.909,8.313c3.506,9.209,3.506,18.993,0,27.409V8.313z M19.715,45.458c0.351-0.554,0.95-0.887,1.599-0.891h28.608
      c0.485-0.035,0.906,0.175,1.238,0.504c0.331,0.329,0.514,0.768,0.514,1.234v0.65H18.607L19.715,45.458z M56.396,56.97
      c-0.871,1.434-2.455,2.325-4.133,2.325H11.736c-1.679,0-3.263-0.891-4.134-2.325l-4.908-8.075h58.611L56.396,56.97z'
    />
  </svg>
);
